import React from 'react';
import { useIntl } from 'react-intl';

import Container from '@/components/Container/Container';
import PageNext from '@/components/Page/PageNext';
import Typography from '@/components/Typography/Typography';
import { NextPage } from '@/pages/_app';

const PersonalDataProcessingConsentPage: NextPage = () => {
  const intl = useIntl();
  return (
    <PageNext title={intl.formatMessage({ id: 'app.personaldataprocessingconsent.pagetitle' })}>
      <Container maxWidth="md" verticalPadding>
        <Typography variant="h2" component="h1" spacing={4}>
          СОГЛАСИЕ ПОЛЬЗОВАТЕЛЯ САЙТА НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          Настоящим свободно, своей волей и в своем интересе даю согласие оператору персональных данных: ООО
          &laquo;Смарт Манкиз&raquo; ОГРН 1187746655359, ИНН/КПП 7743264341 / 774301001, место нахождения 125008, город
          Москва, проезд Черепановых, дом 36 (далее – Оператор), на обработку моих персональных данных, в соответствии
          со следующим перечнем:
        </Typography>
        <ul className="ul">
          <li>Фамилия.</li>
          <li>Имя.</li>
          <li>Отчество.</li>
          <li>Контактный телефон.</li>
          <li>Адрес электронной почты.</li>
          <li>Идентификатор пользователя, хранимый в cookie.</li>
          <li>Образование.</li>
          <li>Профессия.</li>
          <li>Должность.</li>
          <li>Сведения об оказанных услугах.</li>
        </ul>
        <Typography variant="body3" component="div" spacing={3}>
          для достижения таких целей, как:
        </Typography>
        <ul className="ul">
          <li>Соблюдение норм законодательства РФ.</li>
          <li>Заключение и исполнение договоров.</li>
          <li>Информирование о новых товарах, услугах.</li>
          <li>Подготовка индивидуальных предложений.</li>
          <li>Публикация на сайте, во внутренних справочниках, адресных книгах.</li>
          <li>Осуществление деятельности в соответствии с учредительными документами.</li>
        </ul>
        <Typography variant="body3" component="div" spacing={3}>
          Оператор вправе осуществлять обработку моих персональных данных следующими способами: сбор, запись,
          систематизация, накопление, хранение, обновление, изменение, использование, передача (распространение,
          предоставление, доступ). Оператор вправе осуществлять трансграничную передачу моих персональных данных на
          территорию следующих(-ей) стран(-ы): Беларусь.
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          Настоящее согласие вступает в силу и действует в течение сроков, установленных действующим законодательством
          Российской Федерации (далее - РФ). Условием прекращения обработки моих персональных данных является отзыв
          согласия, достижение Оператором целей обработки персональных данных, ликвидация, реорганизация, прекращение
          деятельности Компании.
        </Typography>
        <Typography variant="body3" component="div" spacing={3}>
          Во всем остальном, что не предусмотрено настоящим Согласием, Оператор и Пользователи руководствуются Политикой
          конфиденциальности (далее – Политика) и применимыми нормами действующего законодательства РФ. В случае
          противоречия условий настоящего Согласия условиям Политики подлежат применению условия Политики.
        </Typography>
      </Container>
    </PageNext>
  );
};

export default PersonalDataProcessingConsentPage;
